import _slicedToArray from "/home/runner/work/pc123-gatsby/pc123-gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import * as React from "react";
import { CLASS_FULLSIZE, clsx, cssClass, makeUseContext, PLUGIN_FULLSCREEN, useEventCallback, useLayoutEffect } from "../../core/index.js";
var FullscreenContext = React.createContext(null);
export var useFullscreen = makeUseContext("useFullscreen", "FullscreenContext", FullscreenContext);
export function FullscreenContextProvider(_ref) {
  var auto = _ref.fullscreen,
      children = _ref.children;
  var containerRef = React.useRef(null);

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      fullscreen = _React$useState2[0],
      setFullscreen = _React$useState2[1];

  var _React$useState3 = React.useState(),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      fullscreenEnabled = _React$useState4[0],
      setFullscreenEnabled = _React$useState4[1];

  useLayoutEffect(function () {
    var _a, _b, _c, _d;

    setFullscreenEnabled((_d = (_c = (_b = (_a = document.fullscreenEnabled) !== null && _a !== void 0 ? _a : document.webkitFullscreenEnabled) !== null && _b !== void 0 ? _b : document.mozFullScreenEnabled) !== null && _c !== void 0 ? _c : document.msFullscreenEnabled) !== null && _d !== void 0 ? _d : false);
  }, []);
  var getFullscreenElement = React.useCallback(function () {
    var _a, _b, _c;

    return (_c = (_b = (_a = document.fullscreenElement) !== null && _a !== void 0 ? _a : document.webkitFullscreenElement) !== null && _b !== void 0 ? _b : document.mozFullScreenElement) !== null && _c !== void 0 ? _c : document.msFullscreenElement;
  }, []);
  var requestFullscreen = React.useCallback(function () {
    var container = containerRef.current;

    if (container) {
      try {
        if (container.requestFullscreen) {
          container.requestFullscreen().catch(function () {});
        } else if (container.webkitRequestFullscreen) {
          container.webkitRequestFullscreen();
        } else if (container.mozRequestFullScreen) {
          container.mozRequestFullScreen();
        } else if (container.msRequestFullscreen) {
          container.msRequestFullscreen();
        }
      } catch (err) {}
    }
  }, []);
  var exitFullscreen = React.useCallback(function () {
    if (getFullscreenElement()) {
      try {
        if (document.exitFullscreen) {
          document.exitFullscreen().catch(function () {});
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      } catch (err) {}
    }
  }, [getFullscreenElement]);
  var toggleFullscreen = React.useCallback(function () {
    if (fullscreen) {
      exitFullscreen();
    } else {
      requestFullscreen();
    }
  }, [fullscreen, requestFullscreen, exitFullscreen]);
  var fullscreenChangeListener = React.useCallback(function () {
    if (getFullscreenElement() === containerRef.current) {
      setFullscreen(true);
    } else {
      setFullscreen(false);
    }
  }, [getFullscreenElement]);
  React.useEffect(function () {
    var events = ["fullscreenchange", "webkitfullscreenchange", "mozfullscreenchange", "MSFullscreenChange"];
    events.forEach(function (event) {
      document.addEventListener(event, fullscreenChangeListener);
    });
    return function () {
      events.forEach(function (event) {
        document.removeEventListener(event, fullscreenChangeListener);
      });
    };
  }, [fullscreenChangeListener]);
  var handleAutoFullscreen = useEventCallback(function () {
    if (auto) {
      requestFullscreen();
    }
  });
  React.useEffect(function () {
    handleAutoFullscreen();
    return function () {
      exitFullscreen();
    };
  }, [handleAutoFullscreen, exitFullscreen]);
  var context = React.useMemo(function () {
    return {
      fullscreen: fullscreen,
      fullscreenEnabled: fullscreenEnabled,
      toggleFullscreen: toggleFullscreen
    };
  }, [fullscreen, fullscreenEnabled, toggleFullscreen]);
  return React.createElement("div", {
    ref: containerRef,
    className: clsx(cssClass(PLUGIN_FULLSCREEN), cssClass(CLASS_FULLSIZE))
  }, React.createElement(FullscreenContext.Provider, {
    value: context
  }, children));
}